<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div v-if="stats">
    <h3 class="text-lg leading-6 font-medium text-gray-900" v-if="title">{{ title }}</h3>
    <div v-for="(group, index) in groups" :key="index" class="py-1">
      <dl class="mt-2 grid grid-cols-1 gap-5" :class="`lg:grid-cols-${group.length}`">
        <div
          v-for="key in group"
          :key="key"
          class="px-8 py-4 bg-white shadow rounded-lg overflow-hidden border-l-8 text-gray-500"
          :class="colors[key]"
        >
          <dt class="text-sm font-medium truncate">{{ labels[key] }}</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            <span class="pr-1" v-if="key.includes('amount') || key.includes('price')">&euro;</span>
            <span>{{ Number(typeof stats[key] === 'undefined' ? 0 : stats[key]).toFixed(decimals[key]) }}</span>
            <span v-if="key.includes('perc')">%</span>
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    stats: {
      type: Object,
      default: null,
    },
  },
  setup() {
    const generateName = name => {
      const str = String(name || '')
        .replace(/(_EURO|_PERC)+/gi, '')
        .replace(/_/gi, ' ')
      return `${str[0].toUpperCase()}${str.substr(1)}`
    }
    const decimals = {
      count_invoices: 0,
      sum_price_excl_invoices: 2,
      sum_price_incl_invoices: 2,
      sum_amount_open_invoices: 2,
      count_quotes: 0,
      sum_price_excl_quotes: 2,
      sum_price_incl_quotes: 2,
      count_credit_notes: 0,
      sum_price_excl_credit_notes: 2,
      sum_price_incl_credit_notes: 2,
    }
    const labels = {
      count_invoices: 'Nombre de factures',
      sum_price_excl_invoices: 'Factures valeur (HTVA)',
      sum_price_incl_invoices: 'Factures valeur (TVAC)',
      sum_amount_open_invoices: 'Factures montant ouvert (TVAC)',
      count_quotes: 'Nombre de devis',
      sum_price_excl_quotes: 'Devis valeur (HTVA)',
      sum_price_incl_quotes: 'Devis valeur (TVAC)',
      count_credit_notes: 'Nombre de note de credits',
      sum_price_excl_credit_notes: 'Note de credits valeur (HTVA)',
      sum_price_incl_credit_notes: 'Note de credits valeur (TVAC)',
    }
    const colors = {
      count_invoices: 'border-indigo-500 text-indigo-800',
      sum_price_excl_invoices: 'border-green-600 text-indigo-800',
      sum_price_incl_invoices: 'border-green-400 text-indigo-800',
      sum_amount_open_invoices: 'border-red-500 text-indigo-800',
      count_quotes: 'border-indigo-500 text-indigo-700',
      sum_price_excl_quotes: 'border-green-600 text-indigo-700',
      sum_price_incl_quotes: 'border-green-400 text-indigo-700',
      count_credit_notes: 'border-indigo-500 text-indigo-600',
      sum_price_excl_credit_notes: 'border-green-600 text-indigo-600',
      sum_price_incl_credit_notes: 'border-green-400 text-indigo-600',
    }
    const groups = [
      ['count_quotes', 'sum_price_excl_quotes', 'sum_price_incl_quotes'],
      ['count_invoices', 'sum_price_excl_invoices', 'sum_price_incl_invoices', 'sum_amount_open_invoices'],
      ['count_credit_notes', 'sum_price_excl_credit_notes', 'sum_price_incl_credit_notes'],
    ]
    return { generateName, decimals, groups, colors, labels }
  },
}
</script>

<style></style>
